export const dataAdjustmentResponse = filters => {
  const newData = filters.reduce((acc, value) => {
    let entityTypeKey = value.entityTypeId && value.entityTypeId.entityTypeKey;
    if (entityTypeKey) {
      if (acc[entityTypeKey]) {
        acc[entityTypeKey].filters.push({
          id: value.filterId,
          key: value.filterKey,
          name: value.filter,
        });
      } else {
        acc[entityTypeKey] = {
          entityType: value.entityTypeId.entityType,
          entityTypekey: entityTypeKey,
          entityTypeId: value.entityTypeId.entityTypeId,
          filters: [
            {
              id: value.filterId,
              key: value.filterKey,
              name: value.filter,
            },
          ],
        };
      }
    }
    return acc;
  }, {});

  return newData;
};

export const dataAdjustmentProfileResponse = filters => {
  const newData = filters.reduce(
    (acc, filter) => {
      if (filter.filterId) {
        const { entityTypeKey } = filter.filterId.entityTypeId;
        if (entityTypeKey) {
          if (acc.profileFilters[entityTypeKey]) {
            acc.profileFilters[entityTypeKey].ids.push(
              filter.filterId.filterId
            );
            acc.profileFilters[entityTypeKey].keys.push(
              filter.filterId.filterKey
            );
          } else {
            acc.profileFilters[entityTypeKey] = {
              ids: [filter.filterId.filterId],
              keys: [filter.filterId.filterKey],
            };
          }
          acc.allProfileFilters.ids.push(filter.filterId.filterId);
          acc.allProfileFilters.keys.push(filter.filterId.filterKey);
        }
      }
      return acc;
    },
    {
      profileFilters: {},
      allProfileFilters: { ids: [], keys: [] },
    }
  );

  return newData;
};
